import { XIcon } from 'lucide-react'

import { IconLink } from 'slab'

type Props = {
  logoUrl: string
  closeUrl?: string
}

export function QuoteFlowTopNav ({ logoUrl, closeUrl }: Props) {
  return (
    <div className='flex flex-row items-center justify-between px-6 border-b border-gray-200'>
      <img src={logoUrl} alt='Thatch Logo' className='h-6 my-6' />
      {closeUrl && (
        <IconLink href={closeUrl} icon={XIcon} label='Close' />
      )}
    </div>
  )
}
